<template>
  <div id="campaign-invite">
    <section class="content">
      <div class="box">
        <div class="box-header">
          <button type="button" class="btn btn-primary btn-sm" @click="paginate(1)">
            <i class="fa fa-repeat"></i>
          </button>
        </div>
        <div class="box-body">
          <b-table striped hover :items="campaigns" :fields="fields">
            <template v-slot:cell(actions)="row">
              <div class="btn-group" role="group" aria-label="Basic example">
                <!-- view -->
                <!-- <button type="button" data-toggle="modal" data-target="#view_campaign_modal" class="btn btn-primary" @click="getCampaignDataToView(row.item.id)">
                  <i class="fa fa-eye"></i>
                </button> -->

                <!-- Rate Card "Approve" button -->
                <button type="button" class="btn btn-success btn-sm" @click="approveRateCard(row.item.id, row.item.editRateCard)">
                  <i class="fa fa-check"></i>
                </button>

                <!-- Rate Card "Reject" button -->
                <button type="button" class="btn btn-danger btn-sm" @click="rejectRateCard(row.item.id)">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </template>
          </b-table>
        </div>
        <div class="box-footer">
          <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" size="md" />
        </div>
      </div>
    </section>
    <view-campaign-modal :modalId="'view_campaign_modal'" :campaignData="viewCampaignData" />
  </div>
</template>

<script>
import moment from 'moment'
// import config from '@/config'
import campaignAPIs from './campaignAPIs'
import campaignConfig from './config'
import ViewCampaignModal from './ViewCampaignModal'

export default {
  name: 'campaign-rate-card',
  components: {
    ViewCampaignModal
  },
  data() {
    return {
      campaigns: [],
      currentPage: 1,
      perPage: 15,
      totalRows: 0,
      editRateCardStatus: '',
      fields: [
        {
          key: 'campaign.name'
        },
        {
          key: 'campaign.budget'
        },
        {
          key: 'influencer.instagram.instagramHandle',
          label: 'IG Handle'
        },
        {
          key: 'initialRateCard',
          label: 'Normal Rate Card'
        },
        {
          key: 'editRateCard',
          label: 'Requested Rate Card'
        },
        {
          key: 'actions'
        }
      ],
      viewCampaignData: null
    }
  },
  created() {
    this.paginate(1)
  },
  watch: {
    currentPage() {
      this.paginate(this.currentPage)
    }
  },
  methods: {
    paginate(page = 1) {
      this.currentPage = page
      campaignAPIs
        .paginateRateCard({
          // page: page,
          // per_page: this.perPage,
          editRateCardStatus: 1
          // sort: 'updatedAt DESC'
        })
        .then(response => {
          let campaigns = response

          // campaigns = campaigns.map(item => {
          //   item.updatedAt = this.formatTime(item.updatedAt)
          //   return item
          // })

          this.campaigns = campaigns
          this.totalRows = response.totalCampaigns
        })
        .catch(error => {
          console.log('error', error)
        })
    },

    getCampaignDataToView(campaignID) {
      campaignAPIs
        .getCampaign(campaignID)
        .then(response => {
          this.viewCampaignData = response
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    },

    // approveRateCard(rowID, editRateCard) {
    //   console.log(rowID)
    //   campaignAPIs
    //     .approveRateCard(rowID, editRateCard)
    // },

    // rejectRateCard(rowID) {
    //   console.log(rowID)
    //   campaignAPIs
    //     .rejectRateCard(rowID)
    // },

    approveRateCard(rowID, editRateCard) {
      // Get campaign confirmation configuration
      var rateCardConfirmation = campaignConfig.rateCardConfirmation.approval

      // Display confirmation box
      this.$swal({
        title: rateCardConfirmation['confirmation']['title'],
        text: rateCardConfirmation['confirmation']['text'],
        type: rateCardConfirmation['confirmation']['type'],
        showCancelButton: true,
        confirmButtonText: rateCardConfirmation['confirmation']['confirmText'],
        cancelButtonText: rateCardConfirmation['confirmation']['cancelText'],
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: login => {
          return campaignAPIs
            .approveRateCard(rowID, editRateCard)
            .then(response => {
              return response
            })
            .catch(error => {
              // Request failed.
              console.log('error', error)

              // Show error message
              this.$swal.showValidationError('Something went wrong! Please try again or contact our admin')
            })
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          // Refresh campaign list
          this.paginate(1)

          // Delete local data for the new status list to force refresh
          this.$store.commit('SET_CAMPAIGNS', {
            campaignStatus: campaignConfig.campaignStatusFlow['approve'][this.campaignStatus],
            data: null
          })

          // Show success message
          this.$swal({
            title: rateCardConfirmation['confirm']['title'],
            text: rateCardConfirmation['confirm']['text'],
            type: 'success'
          })
        } else {
          // Do nothing for now
        }
      })
    },
    rejectRateCard(rowID) {
      // Get campaign confirmation configuration
      var rateCardConfirmation = campaignConfig.rateCardConfirmation.rejection

      // Display confirmation box
      this.$swal({
        title: rateCardConfirmation['confirmation']['title'],
        text: rateCardConfirmation['confirmation']['text'],
        type: rateCardConfirmation['confirmation']['type'],
        showCancelButton: true,
        confirmButtonText: rateCardConfirmation['confirmation']['confirmText'],
        cancelButtonText: rateCardConfirmation['confirmation']['cancelText'],
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: login => {
          return campaignAPIs
            .rejectRateCard(rowID)
            .then(response => {
              return response
            })
            .catch(error => {
              // Request failed.
              console.log('error', error)

              // Show error message
              this.$swal.showValidationError('Something went wrong! Please try again or contact our admin')
            })
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          // Refresh campaign list
          this.paginate(1)

          // Delete local data for the new status list to force refresh
          this.$store.commit('SET_CAMPAIGNS', {
            campaignStatus: campaignConfig.campaignStatusFlow['approve'][this.campaignStatus],
            data: null
          })

          // Show success message
          this.$swal({
            title: rateCardConfirmation['confirm']['title'],
            text: rateCardConfirmation['confirm']['text'],
            type: 'success'
          })
        } else {
          // Do nothing for now
        }
      })
    },
    buttonShowPairing(pairingStatus) {
      return pairingStatus === campaignConfig.pairingStatus.INVITED
    },
    formatTime(value) {
      return moment(value).format('YYYY-MM-DD hh:mm:ss')
    }
  }
}
</script>




// WEBPACK FOOTER //
// RateCard.vue?a9a02114